module.exports = __webpack_public_path__ + "static/media/bask.d29fdf23.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/bask.jpg
// module id = 331
// module chunks = 0